import { Injectable } from '@angular/core';
import { Participant } from '../../components/diagram-canvas/models/participant.class';

import {
  ACTOR_LABEL_PLACEMENT,
  ARMS_LENGTH,
  ARMS_PLACEMENT,
  BEGIN_ACTOR,
  BEGIN_ARMS,
  BODY_HEIGHT,
  CANVAS_FONT,
  COMPLETE_ANGLE,
  END_LEFT_LEG_X,
  END_LEGS_Y,
  END_RIGHT_LEG_X,
  HEAD_PLACEMENT,
  HEAD_RADIUS,
  ORIGIN_ANGLE,
} from '../../components/diagram-canvas/constants';
import { ENTITY_HEIGHT, ENTITY_LABEL, ENTITY_WIDTH } from '../../components/diagram-canvas/constants';

@Injectable({ providedIn: 'root' })
export class ParticipantDrawerService {
  private _drawParticipantFunction: Record<Participant['type'], (ctx: CanvasRenderingContext2D, x: number, y: number, name: string) => void> = {
    actor: this.drawActor.bind(this),
    entity: this.drawEntity.bind(this),
  };

  drawAll(ctx: CanvasRenderingContext2D, participants: Participant[]): void {
    ctx.font = CANVAS_FONT;
    participants.forEach(({ x, y, name, type }) => {
      this._drawParticipantFunction[type](ctx, x, y, name);
    });
  }

  drawActor(ctx: CanvasRenderingContext2D, x: number, y: number, name: string): void {
    ctx.beginPath();
    ctx.arc(x + BEGIN_ACTOR, y + HEAD_PLACEMENT, HEAD_RADIUS, ORIGIN_ANGLE, COMPLETE_ANGLE);
    ctx.moveTo(x + BEGIN_ACTOR, y - ARMS_PLACEMENT);
    ctx.lineTo(x + BEGIN_ACTOR, y + BODY_HEIGHT);
    ctx.moveTo(x + BEGIN_ARMS, y + ARMS_PLACEMENT);
    ctx.lineTo(x + BEGIN_ARMS + ARMS_LENGTH, y + ARMS_PLACEMENT);
    ctx.moveTo(x + BEGIN_ACTOR, y + BODY_HEIGHT);
    ctx.lineTo(x + END_LEFT_LEG_X, y + END_LEGS_Y);
    ctx.moveTo(x + BEGIN_ACTOR, y + BODY_HEIGHT);
    ctx.lineTo(x + END_RIGHT_LEG_X, y + END_LEGS_Y);

    ctx.stroke();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(name, x + BEGIN_ACTOR, y + ACTOR_LABEL_PLACEMENT);
  }

  drawEntity(ctx: CanvasRenderingContext2D, x: number, y: number, name: string): void {
    const textWidth = ctx.measureText(name).width;
    const padding = 20;
    const boxWidth = Math.max(ENTITY_WIDTH, textWidth + padding);

    ctx.strokeRect(x, y, boxWidth, ENTITY_HEIGHT);

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(name, x + boxWidth / 2, y + ENTITY_HEIGHT / 2 + ENTITY_LABEL);
  }
}
